import { render, staticRenderFns } from "./tiktok.html?vue&type=template&id=754a8eee&scoped=true&"
import script from "./tiktok.js?vue&type=script&lang=js&"
export * from "./tiktok.js?vue&type=script&lang=js&"
import style0 from "./tiktok.scss?vue&type=style&index=0&id=754a8eee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a8eee",
  null
  
)

export default component.exports